import { useEffect, useState } from "react";
import { fetchpostedInvoices, updateInvoicePostedStatus, updateInvoiceHeader } from "../Api/ViewPostedInvoice";
import { Container, Table, Button, Modal, Form, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { FaPencilAlt, FaCheck, FaPrint } from "react-icons/fa";
import { FaTruckFast } from "react-icons/fa6";
import { useNavigate, Link } from "react-router-dom";
import "../Styling/rawleads.css";
import { useAuth } from "../Context/AuthContext";
const ViewPostedInvoice = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [formData, setFormData] = useState({});
  const{user}=useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadInvoices = async () => {
      try {
        const data = await fetchpostedInvoices(user?.organisationId);
        setInvoices(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching posted Invoices`);
      }
    };

    loadInvoices();
  }, []);

  const handleUpdateStatus = async (invoiceId) => {
    setLoading(prev => ({ ...prev, [invoiceId]: true }));

    try {
      const changedBy = "27";
      await updateInvoicePostedStatus(invoiceId, changedBy);
      toast.success(`✅ Invoice ${invoiceId} posted successfully!`);
      setInvoices(prev => prev.filter(invoice => invoice.invoiceId !== invoiceId));
    } catch (error) {
      toast.error(`❌ Error posting invoice ${invoiceId}`);
      console.error("Error updating invoice status:", error);
    } finally {
      setLoading(prev => ({ ...prev, [invoiceId]: false }));
    }
  };

  const handleEditClick = (invoice) => {
    setEditingInvoice(invoice);
    setFormData({ ...invoice });
    setShowModal(true);
  };

  const handlePrintClick = (invoiceId) => {
    navigate('/invoice', { state: { invoiceId } });
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingInvoice(null);
    setFormData({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!editingInvoice) return;

    try {
      await updateInvoiceHeader(editingInvoice.invoiceId, formData);
      toast.success(`✅ Invoice ${editingInvoice.invoiceId} updated successfully!`);

      // Update the local state with the new data
      setInvoices(prev => prev.map(invoice =>
        invoice.invoiceId === editingInvoice.invoiceId
          ? { ...invoice, ...formData }
          : invoice
      ));

      handleCloseModal();
    } catch (error) {
      toast.error(`❌ Error updating invoice ${editingInvoice.invoiceId}`);
      console.error("Error updating invoice:", error);
    }
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="list-container">
          {/* Header Section with RawLeads styling */}
          <div className="lead-dashboard container-fluid mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h4 className="fw-bold">
                  📋 Posted Invoices Management
                </h4>
                <p className="text-muted">
                  View, manage and update Posted invoices
                </p>
              </div>
              <div>
                <Button variant="outline-primary" className="me-2">
                  📊 Export Data
                </Button>
                <Button className="btn-bulk me-2">
                  ⚡ Bulk Actions
                </Button>
                <Button className="btn-assign me-2">
                  🔄 Refresh
                </Button>
              </div>
            </div>

            {/* Stats Section */}
            <div className="d-flex gap-3 mb-4">
              <div className="stat-card">
                <h5 className="text-primary">{invoices.length}</h5>
                <p className="text-muted">Total Posted</p>
              </div>
              <div className="stat-card">
                <h5 className="text-primary">
                  {invoices.filter(inv => inv.transactionType === 'Sales').length}
                </h5>
                <p className="text-muted">Sales Invoices</p>
              </div>
              <div className="stat-card">
                <h5 className="text-primary">
                  {invoices.filter(inv => inv.transactionType === 'Purchase').length}
                </h5>
                <p className="text-muted">Purchase Invoices</p>
              </div>
              <div className="stat-card">
                <h5 className="text-primary">
                  {invoices.filter(inv => moment(inv.invoiceDate).isSame(moment(), 'month')).length}
                </h5>
                <p className="text-muted">This Month</p>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="raw-leads-table">
            {invoices.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Invoice ID</th>
                    <th>Company Code</th>
                    <th>Invoice Type</th>
                    <th>Category</th>
                    <th>Supply Type</th>
                    <th>Customer Code</th>
                    <th>Project Code</th>
                    <th>Invoice Number</th>
                    <th>Invoice Date</th>
                    <th>Salesperson Code</th>
                    <th>Created At</th>
                    <th>Created By</th>
                    {/*  <th>Changed On Date</th>
                    <th>Changed On Time</th>
                    <th>Changed By</th> */}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.map((invoice, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{invoice.invoiceId.split('-')[0]+invoice.invoiceId.split('-')[5]}</td>
                      <td>{invoice.companyCode}</td>
                      <td>{invoice.transactionType}</td>
                      <td>{invoice.category}</td>
                      <td>{invoice.supplyType || 'N/A'}</td>
                      <td>{invoice.customerCode || 'N/A'}</td>
                      <td>{invoice.projectCode}</td>
                      <td>{invoice.invoiceNumber.split('-')[0]+"-"+invoice.invoiceNumber.split('-')[1]+invoice.invoiceNumber.split('-')[4]+"-"+invoice.invoiceNumber.split('-')[5]}</td>
                      <td>{moment(invoice.invoiceDate).format('L')}</td>
                      <td>{invoice.salespersonCode || 'N/A'}</td>
                      <td>{moment(invoice.createdAt).format('L')} at {moment(invoice.createdAt).format('LTS')}</td>
                      <td>{invoice.createdBy}</td>
                      {/*  <td>{invoice.changedOnDate ? moment(invoice.changedOnDate).format('L') : 'N/A'}</td>
                      <td>{invoice.changedOnTime || 'N/A'}</td>
                      <td>{invoice.changedBy || 'N/A'}</td> */}
                      <td>
                        <div className="d-flex gap-2">
                          {/* <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handleEditClick(invoice)}
                            title="Edit Invoice"
                          >
                            <FaPencilAlt />
                          </Button> */}
                          {/* <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => handleUpdateStatus(invoice.invoiceId)}
                            disabled={loading[invoice.invoiceId]}
                            title="Mark as Posted"
                          >
                            {loading[invoice.invoiceId] ? (
                              <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            ) : (
                              <FaCheck />
                            )}
                          </Button> */}
                          <Button
                            variant="outline-info"
                            title="Print Invoice"
                          >
                            <Link to={`/invoice/${invoice.invoiceId}`}>
                              <FaPrint />
                            </Link>

                          </Button>
                          <Button
                            variant="outline-info"
                            title="Print Invoice"
                          >
                            <Link to={`/invoice/dispatchdetails/${invoice.invoiceId}`}>
                              <FaTruckFast />
                            </Link>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data text-center py-4">No Posted invoices found.</p>
            )}
          </div>
        </Container>

        {/* Edit Modal */}
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Edit Invoice: {editingInvoice?.invoiceId}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="companyCode"
                      value={formData.companyCode || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Invoice Type</Form.Label>
                    <Form.Control
                      type="text"
                      name="transactionType"
                      value={formData.transactionType || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Category</Form.Label>
                    <Form.Control
                      type="text"
                      name="category"
                      value={formData.category || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Supply Type</Form.Label>
                    <Form.Control
                      type="text"
                      name="supplyType"
                      value={formData.supplyType || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Customer Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="customerCode"
                      value={formData.customerCode || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Project Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="projectCode"
                      value={formData.projectCode || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Invoice Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="invoiceNumber"
                      value={formData.invoiceNumber || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Invoice Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="invoiceDate"
                      value={formData.invoiceDate ? moment(formData.invoiceDate).format('YYYY-MM-DD') : ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Salesperson Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="salespersonCode"
                      value={formData.salespersonCode || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Changed By</Form.Label>
                    <Form.Control
                      type="text"
                      name="changedBy"
                      value={formData.changedBy || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Save Changes
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default ViewPostedInvoice;